import { GameplaySystemLogger } from "./SharedGameplaySystemLogger";

export abstract class GameplaySystem extends GameplaySystemLogger {
    public abstract Initialize(): void;
    public abstract Update(deltaTime: number, currentTimeInMilliseconds?: number): void;
    public abstract Cleanup(): void;
}
